<template>
  <div>
    <div id="applyButtonSection" class="white">
      <b-button id="applyButton" @click="goToApplyPage()" variant="success">Solliciteer Direct</b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "DesktopApplyButtonSection",
  props: {
    job: Object
  },
  methods: {
    goToApplyPage() {
      //?titel=jorn zijn vacature&nodeID=5827
      location.href = encodeURI(
        this.$store.state.miscData.ApplyPageURL +
          "?titel=" +
          this.job.Title +
          "&nodeID=" +
          this.job.Id
      );
    }
  }
};
</script>

<style scoped>
/* shared */
#applyButtonSection {
  text-align: center;
  padding: 20px;
}
#applyButton {
  width: 100%;
}

.contactText {
  margin-bottom: 0px;
}

@media screen and (max-width: 991px) {
  #applyButtonSection {
    margin-top: 2px;
  }
}
</style>